<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4>          
            <v-card pa-0>  
              <v-toolbar dense cad flat>
                <v-toolbar-title class="title" :class="fm.status===1?'light-green--text':''" v-if="status.find(x=>x.id===fm.status)">{{status.find(x=>x.id===fm.status).name}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="fm.status === 0" @click="save(isUpdate)" :loading="loading" color="primary">Confirm</v-btn>
                <v-menu bottom left>
                  <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                  <v-list>
                    <v-list-tile v-if="fm.status === 0" v-bind:to="{path:'/signup/calon/payment/form', query: {id: fm.id}}">
                      <v-list-tile-title>Update</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="fm.status === 1" @click="unconfirm()">
                      <v-list-tile-title>Unconfirm</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="fm.status === 0" @click="removePayment()">
                      <v-list-tile-title>Delete</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-bind:to="{path:'/signup/calon/payment/form'}">
                      <v-list-tile-title>New</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-bind:to="{path:'/signup/calon/payment/'}">
                      <v-list-tile-title>Index</v-list-tile-title>
                    </v-list-tile>                    
                  </v-list>
                </v-menu>      
              </v-toolbar>
              <v-divider></v-divider>
              <v-progress-linear slot="progress" color="blue" indeterminate class="ma-0" v-if="loading"></v-progress-linear>                  
              <v-card-text v-if="fm.id">
                <v-container grid-list-lg class="pa-0 ma-0">                  
                  <v-layout row wrap>                     
                    <v-flex lg12 md12 sm12 xs12>
                      <v-list two-line class="pa-0">
                        <v-list-tile style="margin-left:-5px">
                          <v-list-tile-action class="pa-0 ma-0" style="min-width:40px">                
                            <v-icon v-bind:color="'light-green'">payment</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-sub-title>Payment Type</v-list-tile-sub-title>                                                                    
                            <v-list-tile-title v-if="payments.find(x=> x.id === fm.reff_type)">
                              {{payments.find(x=> x.id === fm.reff_type).name}}
                            </v-list-tile-title>                                  
                          </v-list-tile-content>                                                      
                        </v-list-tile> 
                        <v-list-tile style="margin-left:-5px">
                          <v-list-tile-action class="pa-0 ma-0" style="min-width:40px">                
                            <v-icon v-bind:color="'light-green'">monetization_on</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-sub-title>Nominal</v-list-tile-sub-title>                                                                    
                            <v-list-tile-title>
                              {{ fm.nominal | currency }}
                            </v-list-tile-title>                                  
                          </v-list-tile-content>                                                      
                        </v-list-tile>
                        <v-list-tile style="margin-left:-5px">
                          <v-list-tile-action class="pa-0 ma-0" style="min-width:40px">                
                            <v-icon v-bind:color="'light-green'">face</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-sub-title>Atas Nama</v-list-tile-sub-title>                                                                    
                            <v-list-tile-title v-if="siswa.items.find(x=> x.id=== fm.calon_id)">
                              {{ siswa.items.find(x=> x.id=== fm.calon_id).nama }}
                            </v-list-tile-title>                                  
                          </v-list-tile-content>                                                      
                        </v-list-tile>
                        <v-list-tile style="margin-left:-5px">
                          <v-list-tile-action class="pa-0 ma-0" style="min-width:40px">                
                            <v-icon v-bind:color="'light-green'">account_balance_wallet</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-sub-title>Referensi</v-list-tile-sub-title>                                                                    
                            <v-list-tile-title>
                              {{ fm.reff_number }}
                            </v-list-tile-title>                                  
                          </v-list-tile-content>                                                      
                        </v-list-tile>
                        <v-list-tile style="margin-left:-5px">
                          <v-list-tile-action class="pa-0 ma-0" style="min-width:40px">                
                            <v-icon v-bind:color="'light-green'">subject</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-sub-title>Keterangan</v-list-tile-sub-title>                                                                    
                            <p>{{ fm.description }}</p>                               
                          </v-list-tile-content>                                                      
                        </v-list-tile>
                      </v-list>      
                    </v-flex>                    
                  </v-layout>                    
                </v-container>               
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model  from '@/apps/admin/models/Calon';    

var model = new Model();

export default {
  components : {},
  $_veeValidate: {
      validator: 'new'
  },    
  data: () => ({
      showpass:false,
      isEditing:true,
      isUpdate:false,                
      cropshow: false,
      imgUrl : null,
      imgLoading : false,
      saveLoading : false,
      completeLoading : false,    
      fm : {
        calon_id : null,
        reff_type : 1,
        reff_number : null,
        reff_id : null,
        nominal : null,
        status : null,
        calon : {},
      },
      tingkats : [],
      types : [],
      status : [],   
      loading : false,
      siswa : {search:null, loading:false, items:[]},
      payments:[],
  }),
 // created () {this.getParents()},    
  mounted () {
    model.tingkats().then(data=>{this.tingkats = data;});
    model.paymentTypes().then(data=>{this.types = data; });
    model.paymentStatus().then(data=>{this.status = data;});
    model.settings({key:'payment_method'}).then(res=>{
      this.payments = res.value;
    });
    this.$watch(['siswa','search'].join('.'), (newSrc)=>{
      setTimeout(()=>{
        this.search.loading = true;
        if(newSrc === this.siswa.search){
          model.indexSearch({'UserCalonSearch[nama]':newSrc}).then((data)=>{
            this.siswa.items = data; this.search.loading = false;            
          });
        }
      }, 500);
    });
    this.$watch(['fm','calon_id'].join('.'), (newSrc)=>{
      if(newSrc && !this.siswa.items.find(x=>x.id === newSrc)){
        model.indexSearch({'UserCalonSearch[id]':newSrc}).then((data)=>{
          this.siswa.items = data;        
        });
      }      
    });
    this.init();
  }, 
  methods : {
    init(){
      if(this.$route.query.id){
        //this.fm.user_id = this.user.id; this.fm.telepon = this.user.phone;      
        this.isUpdate   = true;
        this.loading = true;
        model.onePayment({id : this.$route.query.id }).then(data => {                     
          Object.assign(this.fm, data === null ? {}:data);          
          this.loading = false;
        });                                               
      }                  
    },
    
    getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; default:return 'black';}
    },

    save(isUpdate = false) {             
      this.loading = true;
      model.confirmPayment(this.fm).then((res)=>{
        if(res.status === 200){
          this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                            
          Object.assign(this.fm, res.data);                   
        }
        this.loading = false;
      });                                     
    },
    
    unconfirm(){
      this.$swal({
          title: 'Are you sure?',  type: 'warning',
          showCancelButton: true, confirmButtonColor: '#FF7F2A', cancelButtonColor: '#2DAC2D', confirmButtonText: 'Yes, unconfirm it!'
      }).then((result) => {                 
        if (result.value) {                    
          model.unconfirmPayment(this.fm).then((res)=>{
            if(res.status === 200){
              this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                            
              Object.assign(this.fm, res.data);                   
            }        
          });
        }
      });                             
    },
    
    removePayment(){
      this.$swal({
          title: 'Are you sure?', text: "You won't be able to revert this!",  type: 'warning',
          showCancelButton: true, confirmButtonColor: '#C81E1E', cancelButtonColor: '#2DAC2D', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {                 
        if (result.value) {                    
          model.removePayment(this.fm).then((res)=>{
            if(res.status === 200){
              this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                            
              this.$router.go(-1);                   
            }        
          });
        }
      });                             
    },

    validate(data){
        data.forEach( (item) => {
            this.$validator.errors.add({field : item.field,msg : item.message});
        });
    },           

    customFilter (item, queryText, itemText) {
        const textOne = item.nama.toLowerCase()
        //const textTwo = item.abbr.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1; 
    },    
      
    
  }
}
</script>